<template>
    <div class="sign">
        <el-dialog title="签名" :visible.sync="dialogVisible" @close="closeDialog"
            width="1000px" class="newIndex">
            <SignCanvas class="sign-canvas" ref="SignCanvas" :options="options" v-model="value" />
            <div slot="footer" class="dialog-footer" style="text-align: center;">
                <el-button type="success" @click="clearSignImg">清空</el-button>
                <el-button type="primary" class="ml30 mr30" @click="saveSignImg" :loading="buttonLoading">保存</el-button>
                <el-button type="danger" @click="back">返回</el-button>
              </div>
        </el-dialog>
    </div>
</template>

<script>
import SignCanvas from "sign-canvas";
import { getCookieForRoleTag} from "@/common/ulit";
    //接口引入
    export default {
        name: "signDialog",
        components: {
            SignCanvas
        },
        props: {
            visible: { //组件传递的值
                type: Boolean,
                default: false,
            },
            src: { // 图片信息Base64
                type: String,
                default: null,
            },
            attributeId: { // 属性ID，用于区分不同的签名字段
                type: [String, Number],
                default: null,
            },
        },
        data() {
            return {
                dialogVisible:false,
                buttonLoading:false,
                value: null,
                currentAttributeId: null, // 保存当前的attributeId，避免被覆盖
                //配置
                options: {
                    lastWriteSpeed: 1, //书写速度 [Number] 可选
                    lastWriteWidth: 2, //下笔的宽度 [Number] 可选
                    lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
                    lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
                    canvasWidth: "950", //canvas宽高 [Number] 可选
                    canvasHeight: "300", //高度  [Number] 可选
                    isShowBorder: false, //是否显示边框 [可选]
                    bgColor: "#ffffff", //背景色 [String] 可选
                    borderWidth: 1, // 网格线宽度  [Number] 可选
                    borderColor: "#ffffff", //网格颜色  [String] 可选
                    writeWidth: 5, //基础轨迹宽度  [Number] 可选
                    maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
                    minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
                    writeColor: "#101010", // 轨迹颜色  [String] 可选
                    isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
                    imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
                },
            };
        },
        created() {

        },
        mounted() {
            this.dialogVisible = this.visible;
        },
        watch: {
            visible(newVal) {
                this.dialogVisible = newVal;
                // 当对话框打开时，保存当前的attributeId
                if(newVal && this.attributeId){
                    this.currentAttributeId = this.attributeId;
                }
            },
            attributeId(newVal) {
                // 当attributeId变化时，更新当前保存的值
                if(this.dialogVisible && newVal){
                    this.currentAttributeId = newVal;
                }
            }
        },
        methods: {
            //清除画板
            clearSignImg() {
                this.$refs.SignCanvas.canvasClear();
            },
            // 保存图片
            saveSignImg() {
                if (this.value == null) {
                    this.$message.warning("请先签名！");
                } else {
                    const img = this.$refs.SignCanvas.saveAsImg(); //base64
                    // 假设base64Data是你的Base64字符串，'image/png'是MIME类型
                    const blob = this.base64ToBlob(img, 'image/png');
                    // 将裁剪图片上传至后台
                    const formData = new FormData();
                    formData.append("file", blob, ".png");
                    this.buttonLoading = true;
                    var xhr = new XMLHttpRequest();
                    xhr.withCredentials = false;
                    xhr.open('POST', this.$baseUrl + "/api/file/update.do");
                    xhr.setRequestHeader("Token", getCookieForRoleTag());
                    xhr.onload = ()=> {
                      var json;
                      if (xhr.status != 200) {
                        this.$message({ type: "warning",message: "上传失败！"});
                        return;
                      }
                      json = JSON.parse(xhr.responseText);
                      if (!json || typeof json.data.url != 'string') {
                        this.$message({ type: "warning",message: "上传失败！"});
                        return;
                      }
                      if (json.code == 0){
                          // this.$message({ type: "success",message: "上传成功！"});
                          this.buttonLoading = false;
                          // 传递签名URL和attributeId，优先使用保存的currentAttributeId
                          let targetAttributeId = this.currentAttributeId || this.attributeId;
                          this.$emit("signValue",json.data.url, targetAttributeId);
                          this.back();
                      }else {
                        this.$message({ type: "warning",message: json.msg});
                      }
                    };
                    xhr.send(formData);
                    // this.$emit("signValue",this.value);
                    // this.back();
                    // this.$dialog
                    //     .confirm({
                    //         title: "签名确认",
                    //         message: "请先确认签名是否正确,一旦签名成功，无法撤销",
                    //     })
                    //     .then(() => {
                    //         console.log(1);
                    //         const img = this.$refs.SignCanvas.saveAsImg();
                    //         this.signShipmentsContractFun(img);
                    //     })
                    //     .catch(() => {
                    //         console.log(2);
                    //         this.$toast.fail({
                    //             message: "签名取消,请重新签名",
                    //             onClose: () => {
                    //                 this.$refs.SignCanvas.canvasClear();
                    //             },
                    //         });
                    //     });
                }
            },
            //下载图片/
            // downloadSignImg() {
            //   this.$refs.SignCanvas.downloadSignImg();
            // },
            back() {
                // this.$router.back(-1);
                this.$emit("closeMsg",false);
            },
            // 签名
            signShipmentsContractFun(img) {
                let params = {
                    contractId: this.$route.query.contractId,
                    carrierContractPicture: img,
                    contractInfoDto: JSON.parse(this.$route.query.contractList),
                };
                console.log(params)
            },
            closeDialog(){
                this.$emit("closeMsg",false);
            },
            base64ToBlob(base64, mimeType) {
              const byteCharacters = atob(base64.split(',')[1]);
              const byteArrays = [];

              for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);
                const byteNumbers = new Array(slice.length);

                for (let i = 0; i < slice.length; i++) {
                  byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
              }

              return new Blob(byteArrays, {type: mimeType});
            }
        },
    };
</script>

<style lang="less" scoped>
    .btnList {
        text-align: center;
        margin: 10px;
    }

    .sign-canvas {
        display: block;
        margin: 0 auto;
        background: #F1F1F1 !important;
        border-radius: 8px;
        border: 1px dashed red;
    }
</style>



// WEBPACK FOOTER //
// src/components/singDiv/index.vue